<div>
    <div class="col pl-0">
        <h4 class="mb-0 font-header" style="font-weight: 700;">Add Manual Timesheets</h4>
    </div>
    <div class="row mb-2 mt-4">
        <div class="col ">
            <div widget class="card border-0 box-shadow">
                <div class="card-header transparent  text-muted">
                    <div class="row">
                        <div class="col-lg-7">
                        </div>
                        <div class="col-lg-1">
                        </div>
                        <div class="col-lg-4">
                            <h5 class="notealert">Note:Row in red color is already entered</h5>
                        </div>
                    </div>
                </div>
                <div class="card-body  widget-body pb-0 pt-2 mb-4">
                    <div class="row">
                        <!-- Client Name -->
                        <div class="col-lg-6">
                            <div class="col-lg-12">
                                <label style="font-weight:bold">Client Name </label>
                            </div>
                            <div class="col-lg-12">
                                <ng-select [(ngModel)]="Client" id="TEClientName"  [searchable]="true" [clearable]="false"
                                    [items]="EntryInputProperty.ClientDropDown" bindLabel="names" class="tdropdown"
                                    bindValue="id" (change)="timesheetclose=true"
                                    (ngModelChange)="showClientDetails(Client)">
                                </ng-select>
                            </div>
                        </div>
                        <!-- Employee Name -->
                        <div class="col-lg-6">
                            <div class="col-lg-12">
                                <label style="font-weight:bold">Employee Name </label>
                            </div>
                            <div class="col-lg-12">
                                <ng-select [(ngModel)]="Employee" id="TEEmployeeName"  [searchable]="true" [clearable]="true"
                                    [items]="EntryInputProperty.EmployeeDropDown" bindLabel="Value" class="tdropdown"
                                    bindValue="Key" (change)="timesheetclose=true"
                                    (ngModelChange)="showEmployeeDetails(Employee);"
                                    [disabled]="Client==undefined || Client==null || Client==0">
                                </ng-select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <!-- Start Date-->
                        <div class="col-lg-3">
                            <div class="col-lg-12">
                                <label style="font-weight:bold">Start Date </label>
                            </div>
                            <div class="col-lg-12">
                                <my-date-picker [options]="myDatePickerOptions" id="TEStartDate" [selDate]="start"
                                    placeholder="mm/dd/yyyy"
                                    (inputFieldChanged)="TimesheetEntryDatePickers($event,'inputchanged','start')"
                                    (dateChanged)="TimesheetEntryDatePickers($event,'datachanged','start');startdates(start, end, Client)"
                                    [disabled]="(Client==undefined || Client==null || Client==0) || (Employee==undefined || Employee==null || Employee==0)">
                                </my-date-picker>
                            </div>
                        </div>
                        <!-- End Date -->
                        <div class="col-lg-3">
                            <div class="col-lg-12">
                                <label style="font-weight:bold">End Date </label>
                            </div>
                            <div class="col-lg-12">
                                <my-date-picker [options]="myDatePickerOptions" id="TEEndDate" [selDate]="end" placeholder="mm/dd/yyyy"
                                    (inputFieldChanged)="TimesheetEntryDatePickers($event,'inputchanged','end')"
                                    (dateChanged)="TimesheetEntryDatePickers($event,'datachanged','end');startdates(start, end, Client)"
                                    [disabled]="isEnableEnd">
                                </my-date-picker>
                            </div>
                        </div>
                        <!-- Service -->
                        <div class="col-lg-6">
                            <div class="col-lg-12">
                                <label style="font-weight:bold">Service </label>
                            </div>
                            <div class="col-lg-12">
                                <ng-select multiple="true" [(ngModel)]="serviceName"  id="TEService" [searchable]="true"
                                    [clearable]="true" [items]="authorizationdetails" class="tdropdown"
                                    bindLabel="Value" bindValue="Key"
                                    (ngModelChange)="showTimesheestoView(start,end,serviceName);"
                                    [disabled]="isEnableservice" >
                                    <!-- <ng-template ng-optgroup-tmp let-item="item">
                                        {{item.type}}
                                    </ng-template> -->
                                </ng-select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <!-- Client Information -->
                        <div class="col-lg-6" *ngIf="isCliInfo">
                            <label class="subtablelabel ml-3">Client
                                Info</label>
                            <ejs-grid [dataSource]='ClientInfoGridList ' allowTextWrap='true'
                                [textWrapSettings]='wrapSettings' [allowResizing]='true' [allowSorting]='false'
                                [allowPaging]='false' [pageSettings]='initialPage' [allowFiltering]='false'
                                (queryCellInfo)='validateClientInformationbutton($event)'>
                                <e-columns>
                                    <!-- Member DOB -->
                                    <e-column minWidth=100 field="dob" headerText="Member DOB" type="date"
                                        [format]='formatOptions'>
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <!-- Member MA# -->
                                    <e-column minWidth=100 field="medicaid" headerText="Member MA#" type="string">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <!-- AKA -->
                                    <e-column minWidth=100 field="aka" headerText="AKA" type="string">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <!-- General Note -->
                                    <e-column minWidth=100 field="generalNote" headerText="General Note" type="string">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                </e-columns>
                            </ejs-grid>
                            <div *ngIf="ClientInfoGridList.length == 0" class="text-center" style="color:red">
                                <p>No data available</p>
                            </div>
                        </div>
                        <!-- Employee Info -->
                        <div class="col-lg-6" *ngIf="isEmp">
                            <label class="subtablelabel ml-3">Employee
                                Info</label>
                            <ejs-grid #gridEmployeeList [dataSource]='EmployeeInfoGridList' allowTextWrap='true'
                                [textWrapSettings]='wrapSettings' [allowResizing]='true' [allowSorting]='false'
                                [allowPaging]='false' [pageSettings]='initialPage' [allowFiltering]='false'
                                (queryCellInfo)='validateEmployeeInformationbutton($event)'>

                                <e-columns>
                                    <!-- UMPI -->
                                    <e-column minWidth=100 field="umpi" headerText="UMPI" type="string">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    Insurance
                                    <!-- Provider ID -->
                                    <e-column minWidth=130 field="payorreqID" headerText="Insurance
                                    Provider ID" type="string">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <!-- AKA -->
                                    <e-column minWidth=100 field="aka" headerText="AKA" type="string">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <!-- Total Hours -->
                                    <e-column minWidth=100 field="totalHoursforEmployee" headerText="Total Hours"
                                        type="number">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                </e-columns>
                            </ejs-grid>
                            <div *ngIf="EmployeeInfoGridList.length == 0" class="text-center" style="color:red">
                                <p>No data available</p>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-lg-12">
                            <div class="row">
                                <div class="col-lg-5">
                                    <label *ngIf="isAuthList || isNotShowAuth" class="subtablelabel ml-3">Authorization Details
                                    </label>
                                </div>
                                <div class="col-lg-7">
                                    <label class="subtablelabel" *ngIf="isNotShowAuth"> Click
                                        Add Authorization to add service details</label>
                                    <button class="m-5" class="btn blue-btn ml-3" *ngIf="isNotShowAuth"
                                        (click)="AddClientAuthorization()">Add New
                                        Authorization</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12" *ngIf="isAuthList || isNotShowAuth">
                            <div class="table-responsive">
                                <table class="table table-hover table-bordered mt-3  ">
                                    <thead style="text-align: center;font-size: smaller;">
                                        <th class="pointer ttablehead" 
                                        
                                        style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;position: relative">
                                            Action
                                        </th>
                                        <th class="pointer ttablehead" style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                                            Start Date
                                        </th>
                                        <th class="pointer ttablehead" style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                                            End Date
                                        </th>
                                        <th class="pointer ttablehead" style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                                            Service
                                        </th>
                                        <th class="pointer ttablehead" style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                                            Description
                                        </th>
                                        <th class="pointer ttablehead" style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                                            Insurance Number#
                                        </th>
                                        <th class="pointer ttablehead" style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                                            Total Units
                                        </th>
                                        <th class="pointer ttablehead" style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                                            Payer Name
                                        </th>
                                        <th class="pointer ttablehead" style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                                            Units Used
                                        </th>
                                        <th class="pointer ttablehead" style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                                            Units Remaining
                                        </th>
                                        <th class="pointer ttablehead" style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                                            Hours Remaining
                                        </th>
                                        <th class="pointer ttablehead" style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                                            Hours/day
                                        </th>
                                        <th class="pointer ttablehead" style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                                            Hours/week
                                        </th>
                                        <th class="pointer ttablehead" style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                                            Remaining Hours/day Based On Last Visit Date
                                        </th>

                                    </thead>
                                    <tbody style="text-align: center;font-size: 12px;">
                                        <tr *ngFor="let specifyAuth of authorizationdetails;let index=index">
                                            <td 
                                            
                                            style="text-align: left;position: relative;background-color:  white;" >
                                                <button class="btn blue-btn btn-sm ml-1 mr-1" style="font-size:11px"
                                                    (click)="selectSpecifyService(specifyAuth.id,specifyAuth)">Select
                                                </button>
                                            </td>

                                            <td>
                                                {{specifyAuth.startDate| date:'MM/dd/yyyy'}}
                                            </td>
                                            <td>
                                                {{specifyAuth.endDate| date:'MM/dd/yyyy'}}
                                            </td>
                                            <td>
                                                {{specifyAuth.masterServiceCode}}
                                            </td>
                                            <td>
                                                {{specifyAuth.serviceDesc}}
                                            </td>
                                            <td>
                                                {{specifyAuth.insuranceNo}}
                                            </td>
                                            <td>
                                                {{specifyAuth.totalUnits}}
                                            </td>
                                            <td>
                                                {{specifyAuth.payorName}}
                                            </td>
                                            <td>
                                                {{specifyAuth.unitsUsed}}
                                            </td>
                                            <td>
                                                {{specifyAuth.unitsRemaining}}
                                            </td>
                                            <td [style.backgroundColor]="isColorEditValue[index]==true?'yellow':''">
                                                {{specifyAuth.remaingHours}}
                                            </td>
                                            <td>
                                                {{specifyAuth.hoursPerDay}}
                                            </td>
                                            <td>
                                                {{specifyAuth.hoursPerWeek}}
                                            </td>
                                            <td>
                                                {{specifyAuth.hoursPerDayBasedOnLastVisitDate}}
                                            </td>

                                        </tr>
                                    </tbody>
                                </table>
                            </div>


                            <div *ngIf="authorizationdetails.length == 0" class="text-center" style="color:red">
                                <p>No data available</p>
                            </div>
                        </div>
                    </div>
                    <div class="row pt-3">
                        <div class="col-lg-5">
                        </div>
                        <div class="col-lg-7 ">
                            <div class="row">
                                <label class="col-lg-4 ">Add Bulk Hours(per day) </label>
                                <div class="col-lg-6 mb-3"> <input type="text" class="form-control"
                                    id="addbulkhours"
                                        [(ngModel)]="Allhours" (keypress)="numberonly($event,'All')"></div>
                                <div class="col-lg-2"><button type="button" class="btn blue-btn btn-sm" 
                                    id="addbulkhoursapply"
                                        (click)="AddHoursForBulkTimsheets()" [disabled]="TimesheetEntryList.length==0">
                                        Apply</button>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-hover table-bordered mt-3 ">
                                <thead>
                                    <th class="pointer" class="text-center"
                                        style="color:white;background-color:  #0D47A1">Services
                                    </th>
                                    <th class="pointer" class="text-center"
                                        style="color:white;background-color:  #0D47A1">Day
                                    </th>
                                    <th class="pointer" class="text-center"
                                        style="color:white;background-color:  #0D47A1">Date
                                    </th>
                                    <th class="pointer" class="text-center"
                                        style="color:white;background-color:  #0D47A1">Total Hours
                                    </th>
                                    <th class="pointer" class="text-center"
                                        style="color:white;background-color:  #0D47A1">E-Timesheet
                                    </th>
                                    <th class="pointer" class="text-center"
                                        style="color:white;background-color:  #0D47A1">Notes
                                    </th>
                                </thead>
                                <tbody class="manualtablescroll ">
                                    <tr *ngFor="let item of TimesheetEntryList;let i=index"
                                        [ngStyle]="{'background-color': (item.isDisable == true) ? '#ff6347' : ((i%2==0)?'#f5f5f5':'#ffffff')}">
                                        <td class="text-center" tabindex="-1"
                                            [ngStyle]="{'color':(item.isDisable == true) ?'white':'black',
                                            'background-color': (item.isDisable == true) ? '#ff6347' : ((i%2==0)?'#f5f5f5':'#ffffff')}">
                                            {{item.service }}
                                        </td>
                                        <td class="text-center" tabindex="-1"
                                            [ngStyle]="{'color':(item.isDisable == true) ?'white':'black'}">
                                            {{item.Day}}
                                        </td>
                                        <td class="text-center" tabindex="-1"
                                            [ngStyle]="{'color':(item.isDisable == true) ?'white':'black'}">
                                            {{item.Date}}
                                        </td>
                                        <!-- Not S0215 Service -->
                                        <td *ngIf="!item.isRemoveS0215HoursValidation" class="text-center"
                                            [attr.contenteditable]="!(item.etimesheet=='Yes')"
                                            [ngStyle]="{'color':(item.isDisable == true) ?'white':'black'}"
                                            (keypress)="numberonly($event,'create')" (focusout)="saveHours($event,i)"
                                            id="editable_div{{i}}">
                                            {{item.tcHours}}
                                        </td>
                                        <!-- S0215 Service -->
                                        <td *ngIf="item.isRemoveS0215HoursValidation" class="text-center"
                                            [attr.contenteditable]="!(item.etimesheet=='Yes')"
                                            [ngStyle]="{'color':(item.isDisable == true) ?'white':'black'}"
                                            (keypress)="numbersOnlyS2015Validation($event,'create')"
                                            (focusout)="saveHours($event,i)" id="editable_div{{i}}">
                                            {{item.tcHours}}
                                        </td>
                                        <td class="text-center" tabindex="-1"
                                            [ngStyle]="{'color':(item.isDisable == true) ?'white':'black'}">
                                            {{item.etimesheet}}
                                        </td>
                                        <td class="text-center" [attr.contenteditable]="true"
                                            [ngStyle]="{'color':(item.isDisable == true) ?'white':'black'}"
                                            (focusout)="saveNotes($event,i)" tabindex="-1">
                                            {{item.notes}}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <!-- Choose file -->
                        <div class="row w-100">
                            <div class="col-6"></div>
                            <div class="col-7">
                                <div class="custom-file ">
                                    <input type="file" #files class="custom-file-input" id="customFile" name="filename"
                                        (change)="onFileChanged($event);selected=!selected;timesheetclose=true"
                                        accept=".pdf" multiple />
                                    <label class="custom-file-label" for="customFile">Choose file</label>
                                </div>
                            </div>
                            <div class="col-1">
                                <button class="btn btnclass" [disabled]="!selected" data-toggle="modal"
                                    data-target="#openpdf"><i class="fa fa-eye fa-lg" style="color:white"></i></button>
                            </div>
                        </div>
                        <div class="row  w-100 mt-1">
                            <div class="col-5">
                                <ng-container *ngIf="selected">
                                    <div *ngFor=" let val of filearray" style=" color: #004290;">
                                        {{val.TimesheetUploadName}}
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-1">
                        <div class="col-lg-6">
                            <label>
                                Entered Total Hours :{{enterdhr}} hrs &nbsp;&nbsp;{{entermin}} mins
                            </label>
                        </div>
                        <div class="col-lg-6 mt-3">
                            <div class="row" class="timesheet-footer">
                                <button class="btn  blue-btn btn-sm Ationsubbtn" [disabled]="start==null ||start==undefined ||start==''||
                                end==null||end==undefined || end==''||
                                Employee==null||Employee==undefined||Employee==0||
                                Client==null ||Client==undefined ||Client==0||
                                serviceName==null||serviceName==''||serviceName==undefined||serviceName.length==0"
                                    (click)="exceedSaveNewHoursList(TimesheetEntryList)">Save & New</button>
                                <button class="btn  blue-btn btn-sm Ationsubbtn"
                                    (click)="exceedSaveHoursList(TimesheetEntryList)"
                                    [disabled]="start==null ||start==undefined ||start==''||
                                end==null||end==undefined || end==''||
                                Employee==null||Employee==undefined||Employee==0||
                                Client==null ||Client==undefined || Client==0|| serviceName==null||serviceName==''||serviceName==undefined||serviceName.length==0">Save
                                    & Close</button>
                                <button class="btn  blue-btn btn-sm  Ationsubbtn"
                                    (click)="backwithalert()">Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<span id="openpdfmodal" data-toggle="modal" data-target="#openpdf"></span>
<div class="modal fade " id="openpdf" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"
    data-backdrop="static">
    <div class="modal-dialog pdfviewmodal" role="document">
        <div class="modal-content ">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">View file</h5>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <!-- <label>{{pdfSrc}}</label> -->
                <pdf-viewer [src]="pdfSrc" [render-text]="true" style="display: block;height:500px"></pdf-viewer>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" data-dismiss="modal">Cancel</button>
            </div>
        </div>
    </div>
</div>
<!-- client-authorization-edit -->
<div *ngIf="EditAuthorization">
    <app-client-authorization-edit *ngIf="EditAuthorization" (EventToEditAuth)="dataEmitfromChild($event)"
        [DataFromAuthorizationList]="authinput">
    </app-client-authorization-edit>
</div>

<!-- opensavemodalalert -->
<span id="openNewModalAlert" data-target="#modalSaveNewalert" data-toggle="modal"></span>
<div class="modal fade" id="modalSaveNewalert" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-backdrop="static">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 style="color:red" id="exampleModalLabel"><span> Authorization Warning</span>
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body" style="color:#004290">
                <div class="row" *ngFor="let errorMessage of exceededHoursMessage">
                    <label class="ml-4">{{errorMessage}}</label>
                    <br>
                </div>
                <div class="modal-footer">
                    <div class="row">
                        <div class="col-lg-8 col-sm-6 col-md-6" style="color:#004290">
                            Note: Click Yes to Save Timesheet or No to return to entry page
                        </div>
                        <div class="col-lg-4 col-sm-6 col-md-6 text-right">
                            <button type="button" class="btn blue-btn btn-sm" data-dismiss="modal" id="savenewYesButton"
                                (click)="saveNewTimesheetList(TimesheetEntryList)" >Yes</button>
                            &nbsp;&nbsp;&nbsp; <button type="button" class="btn blue-btn btn-sm  ml-2 "
                                data-dismiss="modal" id="savenewNoButton">No</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- openSaveandClose -->
<span id="openSaveModalAlert" data-target="#modalSavealert" data-toggle="modal"></span>
<div class="modal fade" id="modalSavealert" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-backdrop="static">
    <div class="modal-dialog " role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 style="color:red" id="exampleModalLabel"><span> Authorization Warning</span>
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body" style="color:#004290">
                <div class="row" *ngFor="let errorMessage of exceededSaveHoursMessage">
                    <label class="ml-4">{{errorMessage}}</label>
                    <br>
                </div>
            </div>
            <div class="modal-footer">
                <div class="row">
                    <div class="col-lg-8 col-sm-6 col-md-6" style="color:#004290">
                        Note: Click Yes to Save Timesheet or No to return to entry page
                    </div>
                    <div class="col-lg-4 col-sm-6 col-md-6 text-right">
                        <button type="button" class="btn blue-btn btn-sm" data-dismiss="modal"
                            (click)="saveTimesheetList(TimesheetEntryList)" id="saveYesButton">Yes</button>
                        <button type="button" class="btn blue-btn btn-sm ml-2" data-dismiss="modal" id="saveNoButton">No</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- close Alert -->
<span id="OpenWithoutSaveTimesheet" data-toggle="modal" data-target="#WithoutSaveTimesheet"></span>
<div class="modal fade modalbackgrod" id="WithoutSaveTimesheet" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLabel" aria-hidden="true" data-backdrop="static">
    <div class="modal-dialog create-update-zip" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">Close</h5>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                You want to close without save?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="timesheetclose=false;backtoTimesheetView()"
                    data-dismiss="modal">Yes</button>
                <button type="button" class="btn blue-btn btn-sm" data-dismiss="modal">No</button>
            </div>
        </div>
    </div>
</div>
<!-- ExceedingAuthLimitModal -->
<span id="openExceedingAuthLimitModalAlert" data-target="#ExceedingAuthLimitModal" data-toggle="modal"></span>
<div class="modal fade" id="ExceedingAuthLimitModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-backdrop="static">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 style="color:red" id="exampleModalLabel"><span> Exceeding Auth Limit</span>
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body" style="color:#004290">
                <div class="row" *ngFor="let errorMessage of exceededAuthLimitMessage">
                    <label class="ml-4">{{errorMessage}}</label>
                    <br>
                </div>
                <div class="modal-footer">
                    <div class="row">
                        <div class="col-lg-6 col-sm-6 col-md-6" style="color:#004290">

                        </div>
                        <div class="col-lg-4 col-sm-6 col-md-6 text-right">
                            <button type="button" class="btn blue-btn btn-sm  ml-2 "
                                data-dismiss="modal">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>